// extracted by mini-css-extract-plugin
export default {"container":"container_container__srhc2","safeAreaContainer":"container_safeAreaContainer__X9X-g"};